import React from 'react';
import sponsorshipBenefitsPdf from 'file-loader?name=docs/[name].[ext]!../../../assets/docs/SPONSORSHIP BENEFITS.pdf';

const ProjectPartners = () => (
	<div className="container main">
		<h2>Project partners</h2>
		<hr/>
		<div className="row">
			<div className="col-sm-6">
				<p>
					We thank the partners listed below for their support of the Portal since its inception in 2012.
					A report outlining enhancements to the Portal between 2015 and 2019 is available <a href="https://www.oecd-ilibrary.org/docserver/d8b0d605-en.pdf?expires=1660149598&id=id&accname=guest&checksum=DC849910BFB79841A703E164596516CA">here</a>.
				</p>
			</div>
			<div className="col-sm-6">
				<p>
					If your organisation is interested in supporting the Portal, please contact the OECD Secretariat at <a href="mailto:GlobalRecallsdata@oecd.org">GlobalRecallsdata@oecd.org</a> for more information.
				</p>
			</div>
		</div>
		<hr/>
		<div className="row partners">
			<div className="col-sm-6">
				<h2>Australia</h2>
				<h4>Australian Competition and Consumer Commission (ACCC)</h4>
				<p>
					The ACCC is an independent statutory agency that promotes competition, fair trading and product safety for the benefit of consumers, businesses and the Australian community.
					The primary responsibilities of the ACCC are to enforce compliance with the competition, consumer protection, fair trading and product safety provisions of the Competition and Consumer Act 2010 (CCA), regulate national infrastructure and undertake market studies.
				</p>
				<p>
					As the national product safety regulator, the ACCC administers a range of mandatory standards and product bans.
					Its role includes identifying and addressing the most significant product safety risks to consumers across Australia.
					It uses a range of strategies to manage significant risks through education and, where necessary, regulation.
				</p>
				<img src={require('../../../assets/images/logos/australian.png')} alt=""/>
				<p>
					<a href="http://www.accc.gov.au/content/index.phtml/itemId/54217#top" target="_blank" className="btn btn-info btn-sm">REPORT A SAFETY CONCERN</a>
				</p>
				<hr/>

				<h2>Brazil</h2>
				<h4>Brazilian National Institute of Metrology, Quality and Technology (Inmetro)</h4>
				<p>
					Inmetro is a federal organization responsible for implementing the national policies on metrology and quality, the Brazilian accreditation body and the focal point for technical barriers to trade in Brazil.
				</p>
				<p>
					As a regulator of more than 140 non-food product categories (listed at <a href="http://inmetro.gov.br/qualidade/rtepac/compulsorios.asp" target="_blank">http://inmetro.gov.br/qualidade/rtepac/compulsorios.asp</a>), Inmetro develops conformity assessment programs with the main objective of improving product safety.
					Products with mandatory conformity assessment programs are monitored in the 26 Brazilian states to protect consumers, removing irregular products from the marketplace.
					Inmetro market surveillance activities help to identify important changes in Brazil’s national standards as well as product design modifications for better safety, as well as giving a technical basis for enforcement actions if necessary.
				</p>
				<img src={require('../../../assets/images/logos/inmetro.png')} alt=""/>
				<p>
					<a href="https://www.gov.br/inmetro/pt-br/canais_atendimento/ouvidoria/faca-sua-manifestacao" target="_blank" className="btn btn-info btn-sm">REPORT A SAFETY CONCERN</a>
				</p>
				<hr/>

				<h2>Canada</h2>
				<h4>Health Canada</h4>
				<p>
					Health Canada is the federal department responsible for helping the people of Canada maintain and improve their health.
					Health Canada is committed to improving the lives of all of Canada&#39;s people and to making the country&#39;s population among the healthiest in the world as measured by longevity, lifestyle and effective use of the public health care system.
				</p>
				<p>
					As part of its role as a regulator, Health Canada helps protect the Canadian public by researching, assessing and collaborating in the management of the health risks and safety hazards associated with the many consumer products and cosmetics that Canadians use every day.
				</p>
				<img src={require('../../../assets/images/logos/canada.png')} alt=""/>
				<p>
					<a href="http://www.healthycanadians.gc.ca/report-signalez/index-eng.php" target="_blank" className="btn btn-info btn-sm">REPORT A SAFETY CONCERN</a>
				</p>
				<hr/>

				<h2>Mexico</h2>
				<h4>Mexican Consumer Protection Federal Agency (Profeco)</h4>
				<p>
					The Consumer Protection Federal Agency (Profeco) of Mexico is a government agency, established on 1976, that
					has administrative authority and has been entrusted to promote and protect the rights and interests of
					consumers, by seeking fairness and legal certainty in the relationships between suppliers and consumers.
				</p>
				<p>
					The legal framework of Profeco foresees as one of the basic principles in consumption relations the	protection of life, health and safety of consumers against risks caused by products,
					practices to supply products, and services considered dangerous or harmful. For this, among its authorities, Profeco enforces and surveils the application of technical standards
					to ensure safety and quality of products, and it also assesses products to guarantee that they comply with technical standards and do not represent a risk to consumer health or safety.
				</p>
				<img src={require('../../../assets/images/logos/profeco.png')} alt=""/>
				<p>
					<a href="https://www.gob.mx/profeco/articulos/proceso-y-requisitos-de-quejas-y-denuncias" target="_blank" className="btn btn-info btn-sm">REPORT A SAFETY CONCERN</a>
				</p>
			</div>

			<div className="col-sm-6">
				<h2>European Commission</h2>
				<h4>European Commission's Directorate-General for Justice and Consumers (DG JUST)</h4>
				<p>
					The Commission helps to shape the EU's overall strategy, proposes new EU laws and policies, monitors their implementation and manages the EU budget.
				</p>
				<p>
					The European Commission&#39;s Directorate-General for Justice and Consumers (DG JUST) helps to ensure that consumer goods sold in the European Union (EU) are safe, that the EU&#39;s internal market works for the benefit of consumers and that the EU helps protect and improve its citizens' health and safety. 
				</p>
				<p>
					DG JUST manages Safety Gate, the rapid alert system for non-food dangerous products.
					This system enables national authorities from the EU and EEA countries to quickly circulate among them all information related to measures taken against dangerous products found on their markets.
					As a result, appropriate action can be taken everywhere in the European single market.
				</p>
				<p>
					Safety Gate covers dangerous non-food products intended for consumers (e.g. a toy, a cosmetic, clothing) and for professionals (e.g. a power drill, a machine, a construction product).
					Thirty countries currently participate in the system (all the EU Member States and the three EEA EFTA states (Norway, Iceland and Liechtenstein).
				</p>
				<p><strong>Legal notice</strong></p>
				<p>
					The data provided by the European Commission are published free of charge on the <a href="https://ec.europa.eu/safety-gate-alerts/screen/webReport" target="_blank">Safety Gate website</a>.
				</p>
				<p>
					The <a href="https://ec.europa.eu/safety/consumers/consumers_safety_gate/menu/documents/Safety_Gate_contacts.pdf" target="_blank">official contact points</a> of the Member States authorities responsible for market surveillance provide the information published on the Safety Gate portal.
					Under the terms of Annex II.10 to the General Product Safety Directive (2001/95/EC), responsibility for the information provided lies with the notifying party.
					The Commission does not take any responsibility for the accuracy of the information provided.
				</p>
				<p><strong>Reuse of alerts</strong></p>
				<p>
					The Commission's reuse policy is set out in the Commission Decision 2011/833/EU of 12 December 2011 on the reuse of Commission documents.
					Reuse of information published on Safety Gate is authorised provided the original meaning or message of the alerts is not distorted and the source is acknowledged.
				</p>
				<p>
					Information on reuse of alerts is available here: <a href="https://ec.europa.eu/safety/consumers/consumers_safety_gate/menu/documents/New_disclaimer_EN.pdf" target="_blank">https://ec.europa.eu/safety/consumers/consumers_safety_gate/menu/documents/New_disclaimer_EN.pdf</a>
				</p>
				<img src={require('../../../assets/images/logos/european.png')} alt=""/>
				<p>
					<a href="mailto:Sanco-Reis@ec.europa.eu" target="_blank" className="btn btn-info btn-sm">REPORT A SAFETY CONCERN</a>
				</p>
				<hr/>

				<h2>United States</h2>
				<h4>U.S. Consumer Product Safety Commission (CPSC)</h4>
				<p>
					The U.S. Consumer Product Safety Commission is charged with protecting the public from unreasonable risks of injury or death from thousands of types of consumer products under the agency&#39;s jurisdiction.
					CPSC is committed to protecting consumers and families from products that pose a fire, electrical, chemical, or mechanical hazard or can injure children.
					CPSC's efforts to ensure the safety of consumer products - such as toys, cribs, power tools, cigarette lighters, and household chemicals – have contributed significantly to the decline in the rate of deaths and injuries associated with consumer products since it began work in 1973.
				</p>
				<img src={require('../../../assets/images/logos/us.png')} alt=""/>
				<p>
					<a href="http://www.saferproducts.gov/" target="_blank" className="btn btn-info btn-sm">REPORT A SAFETY CONCERN</a>
				</p>
				<hr/>

				<h2>GS1</h2>
				<p>
					GS1 is a neutral, not-for-profit, international organisation that develops global standards and solutions to improve the efficiency and visibility of supply chains across industries.
					It engages a global community of trading partners, industry organisations and technology providers to understand their business needs and develops global standards in response to those needs.
					GS1 is driven by close to two million user organisations, in over 20 industries including retail &amp; consumer goods, healthcare, transport &amp; logistics, and more.
					Today, the GS1 System of standards is the most widely used supply chain standards system in the world.
					GS1 has local Member Organisations in over 110 countries and its head office is in Brussels.
					For more information, visit <a href="http://www.gs1.org" target="_blank">www.gs1.org</a>.
				</p>
				<img src={require('../../../assets/images/logos/gs1.png')} alt=""/>
			</div>
		</div>
	</div>
);

export default ProjectPartners;



// WEBPACK FOOTER //
// ./src/views/static/en/project-partners.js